import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { Tooltip } from '@ui/kit';
import { withSlots, Chevron } from '@utils/react';
import { Checkmark } from './atom.checkmark.js';
import { contextMenu, button, heading, description, expandIconWrapper, expandChevron, wrapper } from './finished.card.style.js';
import { iconWrapperCls, expandCls } from './harmonica.card.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const UniversalFinishedCard = withSlots(function UniversalFinishedCard(props) {
  const contextMenu$1 = props.slots.findOne("ContextMenu");
  return /*#__PURE__*/jsxs("div", {
    ref: props.ref,
    className: cx(resets.rootCls, props.className, wrapper),
    children: [contextMenu$1?.children && /*#__PURE__*/jsx("div", {
      className: contextMenu,
      children: contextMenu$1.children
    }), /*#__PURE__*/jsx(Tooltip, {
      body: `Aktiver ${props.title?.trim() || "opgaven"}`,
      ariaType: "label",
      placement: "top",
      pointAt: "toggler",
      children: (containerRef, togglerRef) => /*#__PURE__*/jsxs("button", {
        ref: containerRef,
        onClick: props.onClick,
        className: button,
        children: [props.title && /*#__PURE__*/jsx("div", {
          className: heading,
          children: props.title
        }), /*#__PURE__*/jsx(Checkmark, {
          className: description,
          emphasised: true
        }), /*#__PURE__*/jsx("div", {
          className: cx(expandChevron, expandCls),
          children: /*#__PURE__*/jsx("span", {
            ref: togglerRef,
            className: cx(expandIconWrapper, iconWrapperCls),
            children: /*#__PURE__*/jsx(Chevron, {
              vertical: true,
              size: 10,
              lineWidth: 2
            })
          })
        })]
      })
    })]
  });
});

export { UniversalFinishedCard };
//# sourceMappingURL=finished.card.js.map
